export default "__VITE_ASSET__DkBdVy7o__"